<template>
  <div v-if="!isLoading" class="footer-notice">
    <div class="footer-notice-inner">
      <h2 class="footer-notice-hd">
        <a href="#" @click.prevent="goNoticeList">공지사항</a>
      </h2>

      <button
        type="button"
        :id="'swiper-button-next-footer'"
        class="footer-arrow-left swiper-button-next"
      >
        <img
          :src="require('@/assets/images/common/arrow-footer-left.png')"
          alt="이전목록"
        />
      </button>
      <button
        type="button"
        :id="'swiper-button-prev-footer'"
        class="footer-arrow-right swiper-button-prev"
      >
        <img
          :src="require('@/assets/images/common/arrow-footer-right.png')"
          alt="다음목록"
        />
      </button>

      <div id="footer-notice" class="swiper-container" ref="cellListSwiper">
        <ul class="swiper-wrapper">
          <li
            v-for="(notice, index) in noticeList"
            class="swiper-slide"
            :key="`notice_${index}`"
          >
            <a
              href="javascript:void(0)"
              class="footer-notice-link"
              :title="`공지사항 (${title(notice)})으로 이동`"
              :data-notice-index="index"
              >{{ title(notice) }}</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import Swiper from '@/mixins/swiper'
  import { getNotices } from '@/common/utils/request'
  import { PATH_NAME_NOTICE_LIST } from '@/common/resources/router.const'

  export default {
    name: 'FooterNotice',
    mixins: [Swiper],
    data() {
      return {
        isLoading: true,
        noticeList: [],
        swiperOptions: {
          autoplay: 3500,
          direction: 'vertical',
          autoplayDisableOnInteraction: false,
          centeredSlides: true,
          slidesPerView: 1,
          loop: true,
          nextButton: '#swiper-button-prev-footer',
          prevButton: '#swiper-button-next-footer',
          onClick: (swiper) => {
            const clickedSlideInfo = swiper.clickedSlide
            const idx =
              clickedSlideInfo.getAttribute('data-swiper-slide-index') ?? -1
            return this.goNoticeViewPage(idx)
          },
          onTouchEnd: (swiper) => {
            this.$nextTick(() => {
              const idx = _.get(
                swiper,
                ['clickedSlide', 'dataset', 'swiperSlideIndex'],
                -1,
              )
              return this.goNoticeViewPage(idx)
            })
          },
        },
      }
    },
    mounted() {
      document.addEventListener('keyup', this.keyUpEvent)
    },
    created() {
      this.setNoticeData()
    },
    beforeDestroy() {
      document.removeEventListener('keyup', this.keyUpEvent)
    },
    methods: {
      goNoticeViewPage(idx) {
        const hasIndex = idx > -1
        if (!hasIndex) return

        this.$router.push({
          name: 'notice_view',
          query: {
            filterType: 'all',
            noticeId: this.noticeList[idx]?.noticeid ?? '0',
          },
        })
      },
      title(notice) {
        return notice?.noticetitle ?? ''
      },
      goNoticeList() {
        this.$router.push({ name: PATH_NAME_NOTICE_LIST })
      },
      keyUpEvent(e) {
        const targetIndex = e.target?.dataset?.noticeIndex ?? -1
        if (
          e.target.classList.contains('footer-notice-link') &&
          e.keyCode === 13
        ) {
          this.goNoticeViewPage(targetIndex)
        }
      },
      async setNoticeData() {
        try {
          const { data } = await getNotices({ limit: 5 })
          this.noticeList = data?.list ?? []
          this.isLoading = false
          this.$nextTick(() => {
            this.swiperElement = '#footer-notice'
            this.isReady = true
          })
        } catch (e) {
          console.error(e)
        }
      },
    },
  }
</script>
